
import { ResultData } from "@nt-portal/common-sdk";

import { TCMMasterGroupRule, TCMMasterGroupRuleService } from "@nt-portal/tcm-sdk";
import { BaseClientService } from "../../base-client.service";
import { ControllerOptions, DataController } from "../../../../types";
import { createTCMMasterGroup } from "./master-group.service";
import { LogicalExpression } from "@liminil/data-filter";

export interface TCMMasterGroupRuleOptions extends ControllerOptions<TCMMasterGroupRule> {

}

export const initLogicalExpression = (): LogicalExpression => {
    return { condition: 'and', expressions: [] };
}

export const createTCMMasterGroupRule = (inItem: Partial<TCMMasterGroupRule>) => {
    let item: TCMMasterGroupRule = {
        group: createTCMMasterGroup({}),
        createdBy: ""
    }
    return { ...item, ...inItem }
}

export class ClientTCMMasterGroupRuleService extends BaseClientService implements DataController<TCMMasterGroupRule> {

    private _service: TCMMasterGroupRuleService;


    constructor() {
        super();
        this._service = new TCMMasterGroupRuleService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMMasterGroupRuleOptions): Promise<ResultData<TCMMasterGroupRule>> {
        if (this.params.groupId)
            return await this._service.get(this.buildFetchParams(options), this.token);
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }
    }

    public async import(options: TCMMasterGroupRuleOptions): Promise<any> {
        if (options.file && this.params.groupId)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMMasterGroupRuleOptions): Promise<ArrayBuffer | null> {

        if (this.params.groupId)
            return await this._service.export(this.token, this.buildLookupFetchParams(options), options.filter);
        return null;

    }

    public async getLookup(options: TCMMasterGroupRuleOptions): Promise<ResultData<TCMMasterGroupRule>> {
        if (this.params.groupId) {
            let fetchParams = this.buildLookupFetchParams(options);
            let data = await this._service.get(fetchParams, this.token);
            return data;
        }
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }
    }

    public async getById(options: TCMMasterGroupRuleOptions): Promise<TCMMasterGroupRule | null> {
        if (options.id && this.params.groupId) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMMasterGroupRuleOptions): Promise<any> {
        if (options.id && this.params.groupId)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMMasterGroupRuleOptions): Promise<TCMMasterGroupRule | TCMMasterGroupRule[] | null> {
        if (options.item && options.item.id && this.params.groupId)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMMasterGroupRuleOptions): Promise<TCMMasterGroupRule | TCMMasterGroupRule[] | null> {
        if (options.item && this.params.groupId)
            return await this._service.add(options.item, this.token)
        return null;
    }

    



}